import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { axios } from '../libs/axios';
import { Project } from '../pages/Project';
import logger from '../utils/logger';

export const ProjectAccessWrapper = () => {
  const { projectNo } = useParams();
  const [hasAccess, setHasAccess] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAccess = async () => {
      logger.log('[ProjectAccessWrapper] Checking access for project:', projectNo);
      
      // Check if user has access to this project
      const response = await axios.get(`/projects/${projectNo}`);
      
      logger.log('[ProjectAccessWrapper] Response:', response);
      
      // The axios wrapper returns error data as successful responses
      // Check if the response contains a status field indicating an error
      if (response?.status === 403 || response?.error) {
        logger.log('[ProjectAccessWrapper] Access DENIED - 403 or error in response');
        setHasAccess(false);
        setLoading(false);
        return;
      }
      
      // If we got actual project data (has project_no field), access is granted
      if (response && response.project_no) {
        logger.log('[ProjectAccessWrapper] Access granted - valid project data received');
        setHasAccess(true);
        setLoading(false);
        return;
      }
      
      // Otherwise, something went wrong
      logger.log('[ProjectAccessWrapper] Invalid response, denying access');
      setHasAccess(false);
      setLoading(false);
    };

    checkAccess();
  }, [projectNo]);

  logger.log('[ProjectAccessWrapper] Render - loading:', loading, 'hasAccess:', hasAccess);

  if (loading) {
    return <div style={{padding: '40px', textAlign: 'center', fontSize: '16px'}}>Loading project data...</div>;
  }

  if (!hasAccess) {
    logger.log('[ProjectAccessWrapper] Rendering access denied message');
    return (
      <div style={{padding: '40px', textAlign: 'center'}}>
        <div style={{
          backgroundColor: '#fff5f5',
          border: '1px solid #feb2b2',
          borderRadius: '8px',
          padding: '20px',
          maxWidth: '600px',
          margin: '0 auto'
        }}>
          <h2 style={{color: '#c53030', marginTop: 0}}>Access Denied</h2>
          <p style={{color: '#742a2a', fontSize: '16px'}}>
            You do not have access to this project. Only the project owner can view this project.
          </p>
        </div>
      </div>
    );
  }

  logger.log('[ProjectAccessWrapper] Access granted, rendering Project component');
  return <Project />;
};
